import exhaustivnessCheck from 'common/utils/exhaustivnessCheck';
import { Recipe } from 'common/hooks/useProducer';

import { CardState } from 'features/home/customerHome/localState/states';
import { CardActions } from 'features/home/customerHome/localState/actions';

/**
 * The recipe required by useProducer to transform the AccountState
 */
export const cardRecipe: Recipe<CardState, CardActions> = (draft, action) => {
  switch (action.type) {
    case 'accounts_with_balance/user/started':
      draft.accountsPending = true;
      return;

    case 'accounts_with_balance/user/finished':
      draft.accountsPending = false;
      draft.accounts = action.accounts;
      draft.accountsError = action.error;
      return;

    case 'external_bank_accounts/started':
      draft.bankAccountsPending = true;
      return;

    case 'external_bank_accounts/finished':
      draft.bankAccountsPending = false;
      draft.bankAccounts = action.accounts;
      draft.bankAccountsError = action.error;
      return;

    case 'clients/user/started':
      draft.clientsPending = true;
      return;

    case 'clients/user/finished':
      draft.clientsPending = false;
      draft.clients = action.clients;
      draft.clientsError = action.error;
      return;

    case 'wallets/user/started':
      draft.walletsPending = true;
      return;

    case 'wallets/user/finished':
      draft.walletsPending = false;
      draft.wallets = action.wallets;
      draft.walletsError = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
